const PHONE_CREDIT_PREPAID_URL = `${process.env.API_V4_HOST}/phone-credits/prepaid-transactions`;

export const getPhoneCreditPrepaidTransaction = ($axios, transactionId) =>
  $axios.$get(`${PHONE_CREDIT_PREPAID_URL}/${transactionId}`);

/**
 * @param {object} payload
 * @param {number} payload.transactionId
 * @param {string} payload.action - 'unstuck' | 'cancel_process'
 * @returns {Promise}
 */
export const patchPhoneCreditPrepaidTransactionStatus = ($axios, { transactionId, action }) =>
  $axios.$patch(`${PHONE_CREDIT_PREPAID_URL}/${transactionId}/status`, { id: transactionId, action });
